<script setup>
import { ref, computed, watchEffect, onMounted } from 'vue'
import VLoaderRing from '../VLoaderRing.vue'

const props = defineProps(['src', 'options', 'isVisible'])
const emit = defineEmits(['load', 'update:isVisible'])

const isVisible = ref(false)
const loading = ref(true)

const computedStyle = computed(() => {
  return {}
})

const computedClass = computed(() => {
  const classes = {
    visible: isVisible.value,
    'animation-before': props.options?.animation ? true : false,
    'animation-after': props.options?.animation ? isVisible.value : false,
    [props.options?.imageClass]: props.options?.imageClass || false,
  }

  if (props.options?.borderRadius && props.options?.borderRadius > 0) {
    classes[`rounded -[${props.options.borderRadius}px]`] = true
  }

  return classes
})

function makeVisible() {
  isVisible.value = true
}

function stopLoader() {
  loading.value = false
  emit('load')
}

function watchVisible() {
  watchEffect(() => emit('update:isVisible', isVisible.value))
}

onMounted(() => {
  watchVisible()
})
</script>
<template>
  <VLoaderRing
    v-if="loading && options?.loader"
    class="loader"
    :options="{ size: options?.loaderSize }"
  />

  <img
    v-else
    class="v-image"
    :class="computedClass"
    :style="computedStyle"
    :src="src"
    loading="lazy"
    @load="
      stopLoader();
      makeVisible();
    "
    @error="() => stopLoader()"
  />
</template>
<style scoped>
.v-image {
  width: 100%;
  height: 100%;
  visibility: hidden;
  position: relative;
}

.animation-before {
  transform: scale(0.2);
  opacity: 0.2;
}

.animation-after {
  transform: scale(1);
  opacity: 1;
}

.v-image.visible {
  visibility: visible;
  object-fit: cover;
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0px);
}
@media (max-width: 720px) {
  .v-image.visible {
  object-fit: cover!important;
  }
}
</style>
